import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';

import imgs from '../../utils/images';

const Sidebar = () => {
    const location = useLocation();

    // Define a function to check if a given path is active
    const isActive = (path) => {
        return location.pathname === path;
    };

    // Define your styles for active and inactive links
    const activeStyle = {
        backgroundColor: '#2D8C9A',
        padding: '12px',
        display: 'inline-block',
        borderRadius: '3px'
    };

    const inactiveStyle = {
        padding: '12px',
        display: 'inline-block',
    };
    useEffect(() => {
        document.body.className = "client-pages";
        return () => {
            document.body.className = "";
        }
    }, []);
    return (
        <ul className="sidebar-nav">
            <li className="sidebar-item">
                <Link to="/dashboard" style={isActive('/dashboard') ? activeStyle : inactiveStyle} className="sidebar-link"><img src={imgs.dashboard_icon} alt='dashboard' /> </Link>
            </li>
            {/* <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.schedule_icon} alt='schedule' /> </Link>
            </li>
            <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.sale_icon} alt='sales' /> </Link>
            </li>
            <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.client_list} alt='client' /> </Link>
            </li> */}
            <li className="sidebar-item">
                <Link to="/catalogue/services" className="sidebar-link" style={isActive('/catalogue/services') ? activeStyle : inactiveStyle}><img src={imgs.services_icon} alt='services' /> </Link>
                {/* <ul className="sidebar-dropdown list-unstyled">
                    <li className="sidebar-item">
                        <Link to="/catalogue/services" className="sidebar-link">Services</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Vouchers</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Memberships</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Products</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Notifications</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Inventory</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Stocktakes </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Stock orders </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="" className="sidebar-link">Suppliers </Link>
                    </li>
                </ul> */}
            </li>
            {/* <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.profile_icon} alt='profile' /> </Link>
            </li>
            <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.promote_icon} alt='promote' /> </Link>
            </li>
            <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.report_icon} alt='report' /> </Link>
            </li> */}
            <li className="sidebar-item">
                <Link to="/appointments" className="sidebar-link" style={isActive('/appointments') ? activeStyle : inactiveStyle}><img src={imgs.appointment_icon} alt='business' /> </Link>
            </li>
            <li className="sidebar-item">
                <Link to="/business-settings" className="sidebar-link" style={isActive('/business-settings') ? activeStyle : inactiveStyle}><img src={imgs.business_icon} alt='business' /> </Link>
            </li>
            {/* <li className="sidebar-item">
                <Link to="" className="sidebar-link"><img src={imgs.support_icon} alt='support' /> </Link>
            </li> */}
        </ul>
    )
}

export default Sidebar;
